
































































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Target, User, AdcontrolProfile } from "@/models";

import MediaSelect from "@/components/MediaSelect.vue";
import VMultiSwitcher from "@/components/VMultiSwitcher.vue";
import DatePicker, { DATE_FORMAT } from "@/components/DatePicker.vue";
import TimeSlotPicker from "@/components/TimeSlotPicker.vue";
import VListGroup from "@/components/VListGroup.vue";
import TaxonomySelectV2 from "@/components/TaxonomySelectV2.vue";
import VSwitchButton from "@/components/VSwitchButton.vue";
import EntryItem from "@/components/EntryItem.vue";
import TopList, {
  TopListFilter,
  UnitOfMeasure,
} from "@/components/Investor/TopList.vue";

import SelectOption from "@/interfaces/SelectOption";

import { Company } from "@/models";
import InvestorsMixins from "@/mixins/http/Investor";
import MediaValue from "@/interfaces/MediaValue";
import QueryParser from "@/services/QueryParser";
import QueryHelper from "@/services/QueryHelper";
import { FEATURE_AUDITEL, FEATURE_CURRENCY_UNIT } from "@/constants";
import GrpTargetSelect from "@/components/GrpTargetSelect.vue";

import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import MultiLevelObject from "@/interfaces/MultiLevelObject";

import GrpDisclaimer from "@/components/GrpTargets/Disclaimer.vue";
import Taxonomy from "@/interfaces/Taxonomy";
import Compressor from "@/services/Compressor";

import InvestorVodDisclaimer from "@/components/Investor/VodDisclaimer.vue";
import PageGuide, { GuidePaths } from "@/components/PageGuide.vue";

type DateValue = string | Date | undefined;
Component.registerHooks(["beforeRouteUpdate"]);

interface DateRange {
  from: string;
  to: string;
}

interface TvRadioTopFilter {
  radioUnitOfMeasure: UnitOfMeasure;
  tvUnitOfMeasure: UnitOfMeasure;
  currencyUnitOfMeasure?: UnitOfMeasure;
}

const DEFAULT_FILTER: Readonly<TopListFilter> = {
  media: { radio: true, tv: true },
  date: { from: "", to: "" },
  compare: { from: "", to: "" },
  groupBy: Company.type,
  grpTarget: null,
  taxonomy: { sector: undefined, category: undefined, class: undefined },
  timeSlots: [],
  detectionChoice: "spot",
  grpChoice: "grp",
};

const DEFAULT_TV_RADIO_FILTER: Readonly<TvRadioTopFilter> = {
  radioUnitOfMeasure: "seconds",
  tvUnitOfMeasure: "seconds",
  currencyUnitOfMeasure: "ebiquity_min",
};

@Component({
  components: {
    MediaSelect,
    VMultiSwitcher,
    DatePicker,
    TimeSlotPicker,
    TaxonomySelectV2,
    VSwitchButton,
    VListGroup,
    EntryItem,
    TopList,
    GrpTargetSelect,
    MultiLevelSelect,
    GrpDisclaimer,
    InvestorVodDisclaimer,
    PageGuide,
  },
})
export default class TopInvestor extends Mixins(InvestorsMixins) {
  guidePath = GuidePaths.INVESTOR_TOP;

  @Getter readonly parseAndCleanMediaValue!: (
    radio: string | boolean | undefined,
    tv: string | boolean | undefined
  ) => MediaValue;
  // eslint-disable-next-line
  @Getter readonly parseDateValue!: (
    date: string,
    format: string,
    defaultOffset?: number,
    defaultUnit?: string
  ) => string;
  @Getter("lastDate") readonly lastDate!: string;
  @Getter("user") readonly user!: User;
  @Getter("profile") readonly profile!: AdcontrolProfile;
  @Getter("taxonomies") readonly taxonomies!: Array<Taxonomy>;

  filter: TopListFilter = { ...DEFAULT_FILTER };
  tvRadioFilter: TvRadioTopFilter = { ...DEFAULT_TV_RADIO_FILTER };
  target: Target | null = null;

  created() {
    this.filter = { ...this.buildFilterFromQuery() };
    this.tvRadioFilter = { ...this.buildTvRadioFilterFromQuery() };
  }

  @Watch("$store.state.settings.profile")
  onProfileChanged() {
    this.filter = { ...this.buildFilterFromQuery() };
  }

  @Watch("filter", { deep: true })
  @Watch("tvRadioFilter", { deep: true })
  onFilterChanged() {
    if (!QueryHelper.isSameQuery(this.$route.query, this.queryFilter)) {
      this.$router.replace({ query: { ...this.queryFilter } });
    }
  }

  get radioTopListFilter() {
    return {
      ...this.flatFilter,
      media: { radio: true, tv: false },
    };
  }

  get tvTopListFilter() {
    return {
      ...this.flatFilter,
      media: { radio: false, tv: true },
    };
  }

  get currencyTopListFilter() {
    return {
      ...this.flatFilter,
      media: { radio: true, tv: false },
    };
  }

  get hasEbiquityFeature(): boolean {
    return this.user.profile?.hasFeature(FEATURE_CURRENCY_UNIT) || false;
  }

  get showCurrencyValues(): boolean {
    return this.hasEbiquityFeature && this.isRadioOnlyView;
  }

  get isAgency(): boolean {
    return this.user.profile?.isAgency || false;
  }

  get isTv(): boolean {
    return this.profile?.accountType === "tv";
  }

  get auditelDisabled(): boolean {
    if (this.isAgency) {
      return this.profile?.accountType != "tv";
    }
    return !this.filter.media.tv;
  }

  get queryFilter() {
    // eslint-disable-next-line
    const query: any = {
      from: this.filter.date.from,
      to: this.filter.date.to,
      tv: this.filter.media.tv ? "1" : "0",
      radio: this.filter.media.radio ? "1" : "0",
      group_by: this.filter.groupBy,
      sector: Compressor.compress(this.filter.taxonomy.sector as string[]),
      category: Compressor.compress(this.filter.taxonomy.category as string[]),
      class: Compressor.compress(this.filter.taxonomy.class as string[]),
      detection_choice: this.filter.detectionChoice,
      grp_choice: this.filter.grpChoice,
    };
    if (this.isAgency) {
      query.radio = this.profile?.accountType !== "tv" ? "1" : "0";
      query.tv = this.profile?.accountType === "tv" ? "1" : "0";
    }
    if (this.filter.timeSlots && this.filter.timeSlots.length > 0) {
      query.slots_from = [
        ...this.filter.timeSlots.map((slot) => slot.from as string),
      ];
      query.slots_to = [
        ...this.filter.timeSlots.map((slot) => slot.to as string),
      ];
    }
    if (this.isTvRadioView) {
      query.radioUnitOfMeasure = this.tvRadioFilter.radioUnitOfMeasure;
      query.tvUnitOfMeasure = this.tvRadioFilter.tvUnitOfMeasure;
    }
    return query;
  }

  get hasAuditelCapability() {
    if (this.isAgency) {
      return this.user.hasFeature(FEATURE_AUDITEL) && this.isTv;
    }
    return this.user.hasFeature(FEATURE_AUDITEL);
  }

  get isClassicView() {
    if (this.isAgency) {
      return !this.hasAuditelCapability || this.target == null;
    }
    return (
      !this.hasAuditelCapability ||
      this.target == null ||
      this.filter.media.radio
    );
  }

  get isTvRadioView() {
    return this.filter.media.radio && this.filter.media.tv;
  }

  get isRadioOnlyView() {
    return this.filter.media.radio && !this.filter.media.tv;
  }

  get flatFilter() {
    const classes = new Set<string>(this.filter.taxonomy.class);

    for (const sector of this.filter.taxonomy.sector ?? []) {
      const tax = this.taxonomies.find((t) => t.id === sector);
      for (const cat of tax?.categories ?? []) {
        cat.classes?.forEach((c) => classes.add(c.id));
      }
    }

    for (const catId of this.filter.taxonomy.category ?? []) {
      const categories = this.taxonomies.reduce(
        (acc, t) => [...acc, ...(t.categories ?? [])],
        [] as Taxonomy[]
      );
      const cat = categories.find((c) => c.id === catId);
      cat?.classes?.forEach((c) => classes.add(c.id));
    }

    return {
      ...this.filter,
      taxonomy: {
        class: [...classes.values()],
      },
    };
  }

  get showOnlyVodData(): boolean {
    return this.profile?.mediaSourceKind === "msk_vod";
  }

  get isVodOnly(): boolean {
    return this.profile?.mediaSourceKind === "msk_vod";
  }

  items = {
    second: [],
    spot: [],
  };

  compare = {
    second: new Map(),
    spot: new Map(),
  };

  detectionOptions: MultiLevelObject[] = [
    {
      id: "spot",
      text: "Spot",
    },
    {
      id: "seconds",
      text: "Secondi",
    },
  ];
  grpOptions: MultiLevelObject[] = [
    {
      id: "grp",
      text: "GRP",
    },
    {
      id: "grp_over_spots",
      text: "GRP / Spot",
    },
    {
      id: "audience",
      text: "Contatti",
    },
  ];

  shareOfVoice = false;
  colors = new Map();
  logoUrls = new Map<string, string[]>();

  overItem: Company | undefined = new Company({});

  get disablePopover(): boolean {
    return !(this.filter.media.radio && this.filter.media.tv);
  }

  get spotTopList(): TopList | null {
    return (this.$refs.spotTopList as TopList) || null;
  }

  get secondsTopList(): TopList | null {
    return (this.$refs.secondsTopList as TopList) || null;
  }

  get loading(): boolean {
    if (this.spotTopList == null || this.secondsTopList == null) {
      return false;
    } else {
      return this.spotTopList.loading || this.secondsTopList.loading;
    }
  }

  get targetId(): string {
    return this.target?.id || "";
  }

  radioUnitSelectorOptions: Array<MultiLevelObject> = [
    { id: "seconds", text: "Secondi" },
    { id: "spots", text: "Spot" },
  ];

  currencyUnitSelectorOptions: Array<MultiLevelObject> = [
    { id: "ebiquity_min", text: "€ (Stima Min.)" },
    { id: "ebiquity_max", text: "€ (Stima Max.)" },
  ];

  get tvUnitSelectorOptions(): Array<MultiLevelObject> {
    const alwaysOn = [
      { id: "seconds", text: "Secondi" },
      { id: "spots", text: "Spot" },
    ];

    if (this.hasAuditel) {
      return [
        ...alwaysOn,
        { id: "grp", text: "GRP" },
        { id: "grp_over_spots", text: "GRP / Spot" },
        { id: "audience", text: "Contatti" },
      ];
    } else {
      return alwaysOn;
    }
  }

  get hasAuditel(): boolean {
    return this.user.hasFeature(FEATURE_AUDITEL);
  }

  private groupByItems: Array<SelectOption> = [
    { id: "companies", text: "Azienda" },
    { id: "brands", text: "Brand" },
    { id: "products", text: "Prodotto" },
  ];

  buildFilterFromQuery(): TopListFilter {
    const query = this.$route.query;
    const { radio, tv, slots_from, slots_to, detection_choice, grp_choice } =
      query;

    const from = this.parseDateValue(
      query.from as string,
      DATE_FORMAT,
      6,
      "days"
    );
    const to = this.parseDateValue(query.to as string, DATE_FORMAT);
    const date = { from, to };
    const compare = {
      from: this.$moment(from)
        .subtract(6, "days")
        .subtract(1, "years")
        .format(DATE_FORMAT),
      to: this.$moment(to).subtract(1, "years").format(DATE_FORMAT),
    };
    let media = this.parseAndCleanMediaValue(
      QueryParser.queryToBoolean(radio),
      QueryParser.queryToBoolean(tv)
    );
    const groupBy = (this.$route.query.group_by as string) || Company.type;
    const taxonomy = {
      sector:
        (Compressor.decompress(query.sector as string) as string[]) ||
        undefined,
      category:
        (Compressor.decompress(query.category as string) as string[]) ||
        undefined,
      class:
        (Compressor.decompress(query.class as string) as string[]) || undefined,
    };
    const timeSlots: DateRange[] = [];
    if (slots_from) {
      if (Array.isArray(slots_from)) {
        slots_from.forEach((slot, index) => {
          timeSlots.push({
            from: slot as string,
            to: slots_to[index] as string,
          });
        });
      } else {
        timeSlots.push({ from: slots_from as string, to: slots_to as string });
      }
    }

    if (this.isAgency) {
      if (this.profile?.accountType === "tv") {
        media = { radio: false, tv: true };
      } else {
        media = { radio: true, tv: false };
      }
    }

    const detectionChoice = (detection_choice as string | undefined) ?? "spot";
    const grpChoice = (grp_choice as string | undefined) ?? "grp";
    const grpTarget = this.hasAuditelCapability
      ? this.target?.id || null
      : null;

    return {
      date,
      compare,
      media,
      groupBy,
      taxonomy,
      timeSlots,
      grpTarget: grpTarget,
      detectionChoice,
      grpChoice,
    };
  }

  buildTvRadioFilterFromQuery(): TvRadioTopFilter {
    const query = this.$route.query;

    const radioUnitOfMeasure =
      (query.radioUnitOfMeasure as UnitOfMeasure) ?? "seconds";
    const tvUnitOfMeasure =
      (query.tvUnitOfMeasure as UnitOfMeasure) ?? "seconds";

    const currencyUnitOfMeasure =
      (query.currencyUnitOfMeasure as UnitOfMeasure) ?? "ebiquity_min";

    return {
      radioUnitOfMeasure,
      tvUnitOfMeasure,
      currencyUnitOfMeasure,
    };
  }

  isOver(item: { id: string }) {
    if (this.overItem == undefined) {
      return false;
    }

    return this.overItem.id == item.id;
  }

  onItemOver(item: Company | undefined) {
    this.overItem = item;
  }

  onDateSelected({
    range,
    compare,
  }: {
    range: { from: string; to: string };
    compare: { from: string; to: string };
  }) {
    if (range) {
      this.filter.date = range;
    }

    if (compare) {
      this.filter.compare = compare;
    }
  }

  onGrpTargetChanged(target: Target) {
    this.target = target;
    this.filter.grpTarget = this.target?.id;
  }

  getUnitOfMeasureName(unitOfMeasure: string) {
    switch (unitOfMeasure) {
      case "seconds":
        return "secondi";
      case "spots":
        return "n° spot";
      case "grp":
        return "GRP";
      case "grp_over_spots":
        return "GRP / n° spot";
      case "audience":
        return "contatti";
      case "ebiquity_min":
        return "€ Stima Min.";
      case "ebiquity_max":
        return "€ Stima Max.";
      default:
        return "dati";
    }
  }
}
